import React, { FC } from 'react'
import { Icon } from '@iconify/react'

import { Input } from '@pepper/ui'

import styles from './_.module.css'

interface Props {
  placeholder?: string
  searchOnChange: (val: string) => void
  value?: string
}

const SearchView: FC<Props> = ({ placeholder, searchOnChange, value }) => {
  return (
    <Input
      allowClear={true}
      className={styles.searchInput}
      prefix={<Icon icon="lucide:search" className={styles.searchIcon} />}
      placeholder={placeholder}
      onChange={e => searchOnChange(e.target.value)}
      value={value ?? ''}
    />
  )
}

export default SearchView
